import { AnyBoosterType, BoosterType, PreBoosterType } from '../State/Card/BoosterType';
import { IRewardData, RewardType } from '../Utility/RewardHelper';

/**
 * Multiplier for coin reward
 */
export const levelCoinCollectMultiplier: number = 0.00125;

/**
 * Multiplier (per uses count) for the cost of the boosters
 */
// prettier-ignore
export const multiplierPerBoosterType: Record<AnyBoosterType, ReadonlyArray<number>> = {
    [BoosterType.BULLS_EYE]: [2, 3, 4, 5, 6],
    [BoosterType.JOKER]: [2.5, 3.5, 4.5, 5.5, 6.5],
    [BoosterType.PLUS_ONE]: [0],
    [BoosterType.PLUS_THREE]: [0],
    [BoosterType.PLUS_FIVE]: [1.5, 2.5, 3.5, 4.5, 5.5],
    [BoosterType.SHUFFLE]: [1.0, 1.5, 2.0, 2.5, 3.0],
    [BoosterType.TNT]: [5, 6.5, 8, 9.5, 11],
    [BoosterType.UNDO]: [0.2, 0.4, 0.8, 1, 1.2],

    [PreBoosterType.REMOVE_THREE]: [1.5],
    [PreBoosterType.JOKER]: [3],
    [PreBoosterType.CANISTER]: [5],
};

/**
 * Array of level complete reward multipliers with each index relating to the number of stars earned
 */
export const levelCompleteRewardMultiplier: number[] = [0.8, 1, 1.2];
/**
 * How much currency should the player start with
 */
export const newPlayerCurrencyAmount: number = 10000;

/**
 * the start amount factor the user gets after completing a level for the first time
 */
export const remainingStackRewardStartFactor: number = 0.02;
/**
 * the linear factor amount per card left in the stack
 */
export const remainingStackRewardStartLinearFactor: number = 0.005;

export const BASE_HARVEST_REWARD: number = 1000;
export const HARVEST_REWARD_INCREMENT: number = 10;
export const HARVEST_REWARD_MULTIPLIER: number = 25;

export const currencySendReward: IRewardData = {
    type: RewardType.COINS,
    value: 500,
};
export const currencyShareReward: IRewardData = {
    type: RewardType.COINS,
    value: 500,
};
export const FRIEND_GIFT_REWARD: IRewardData = {
    type: RewardType.COINS,
    value: 100,
};
export const inviteShareReward: IRewardData = {
    type: RewardType.COINS,
    value: 10000,
};
export const shopGiftReward: IRewardData = {
    type: RewardType.FREE_PLAY,
    value: 1,

    // hours between being eligible to claim gift
    cooldownTimer: 23,
};

export const freeSpinsOnUnlock: number = 1;
export const replayCostMultiplier: number = 0.4;
